import type { SVGProps } from "react";
export interface MapLocationIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MapLocationIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MapLocationIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 15.4c0-1.7-1.504-3.275-3.375-3.275S14.125 13.7 14.125 15.4v.3l.006.196c.058.973.546 1.951 1.25 2.856.703.904 1.546 1.633 2.119 2.079.573-.447 1.416-1.175 2.12-2.079.75-.965 1.255-2.014 1.255-3.051v-.3ZM17 15.126a.62.62 0 0 0-.125.374l.013.126a.6.6 0 0 0 .112.246v-.745Zm1 .746a.6.6 0 0 0 .112-.246l.014-.126-.014-.126a.6.6 0 0 0-.112-.248zm1.125-.372a1.624 1.624 0 0 1-3.242.165l-.007-.165.007-.165a1.625 1.625 0 0 1 1.617-1.46l.166.008c.82.083 1.459.775 1.459 1.617m4 .2c0 1.752-.835 3.283-1.73 4.433-.905 1.163-1.963 2.056-2.615 2.555a2.1 2.1 0 0 1-2.56 0c-.652-.499-1.71-1.392-2.615-2.555-.839-1.078-1.625-2.49-1.72-4.106l-.01-.326v-.3c0-2.958 2.525-5.526 5.625-5.526s5.625 2.568 5.625 5.525z"
      />
      <path
        fill={color}
        d="M14.375 7.239V5.708l-4.75-2.272V18.29l.807.386.1.056a1.126 1.126 0 0 1-.966 2.018l-.107-.044-.94-.45-4.546 2.343C2.56 23.328.875 22.3.875 20.71V6.22c0-1.17.654-2.241 1.693-2.777L6.66 1.334l.218-.104A4.1 4.1 0 0 1 8.497.877L8.5.875l.005.002a4.1 4.1 0 0 1 1.824.403l5.15 2.464 4.547-2.341.268-.117c1.35-.482 2.83.514 2.83 2.005v5.002a1.125 1.125 0 0 1-2.25 0V3.496l-4.249 2.189v1.554a1.125 1.125 0 0 1-2.25 0M3.125 20.504l4.25-2.191V3.496L3.6 5.441a.88.88 0 0 0-.475.778z"
      />
    </svg>
  );
}
